import { ProspectStatistic } from './prospect-statistic';

export class ProspectStatisticWrapper {
  userId: number;
  statistic: ProspectStatistic;
}
